/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/training.scss';
import Paging from '../../component/Inc/Paging';
import Tab from '../../component/Inc/Tab';
import PopTrainingNotice from './_PopTrainingNotice';
import BtnLike from "../../component/Inc/BtnLike";//좋아요 버튼

const Notice = () => {
  const [modalTrainingNotice, setModalTrainingNotice] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '공고중', cnt: '46', value: 0},
    {title: '교사교육 진행중', cnt: '653', value: 1},
    {title: '수업완료', cnt: '652', value: 2},
    {title: '내 교사교육', cnt: '652', value: 3}
  ];
  return (
    <main className="com_container com_training p_training_notice">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu6_6">교사 교육 공고</h2>
          <button onClick={() => setModalTrainingNotice(true)} className="com_btn orange s btn_plus">
            공고 등록
          </button>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <section className="com_board_search">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="7%" />
                <col width="10%" />
                <col width="10%" />
                <col width="9%" />
                <col width="33%" />
                <col width="7%" />
                <col width="9%" />
                <col width="5%" />
                <col width="15%" />
                <col width="9%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>등록일</th>
                  <th>교관</th>
                  <th>교육</th>
                  <th>공고명</th>
                  <th>파일</th>
                  <th>등록자</th>
                  <th>참여자</th>
                  <th>비고</th>
                  <th>출석부</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <BtnLike/>
                  </td>
                  <td className="td_date">2022,08,25</td>
                  <td>홍길동103</td>
                  <td className="td_point">입사자 재교육</td>
                  <td>1월9일 교사 교육 대상자 입니다.</td>
                  <td>
                    <button className="btn_link point">다운로드</button>
                  </td>
                  <td>김길동103</td>
                  <td>8</td>
                  <td className="td_red">공고중</td>
                  <td>
                    <button className="btn_link blue">보기</button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="icon_new" />
                    17
                  </td>
                  <td className="td_date">2022,08,25</td>
                  <td>홍길동103</td>
                  <td className="td_point">보수교육</td>
                  <td>신입 교사 연수 공지입니다. 2022년 교사님…</td>
                  <td>
                    <button className="btn_link point">다운로드</button>
                  </td>
                  <td>김길동103</td>
                  <td>8</td>
                  <td className="td_point">교사교육 진행중</td>
                  <td>
                    <button className="btn_link blue">보기</button>
                  </td>
                </tr>
                <tr>
                  <td>17</td>
                  <td className="td_date">2022,08,25</td>
                  <td>홍길동103</td>
                  <td className="td_point">보수교육</td>
                  <td>신입 교사 연수 공지입니다. 2022년 교사님…</td>
                  <td>
                    <button className="btn_link point">다운로드</button>
                  </td>
                  <td>김길동103</td>
                  <td>8</td>
                  <td className="td_point">수업 완료</td>
                  <td>
                    <button className="btn_link blue">보기</button>
                  </td>
                </tr>
                <tr>
                  <td>17</td>
                  <td className="td_date">2022,08,25</td>
                  <td>홍길동103</td>
                  <td className="td_point">보수교육</td>
                  <td>신입 교사 연수 공지입니다. 2022년 교사님…</td>
                  <td>
                    <button className="btn_link point">다운로드</button>
                  </td>
                  <td>김길동103</td>
                  <td>8</td>
                  <td></td>
                  <td>
                    <button className="btn_link blue">보기</button>
                  </td>
                </tr>
                <tr className="selected">
                  <td>17</td>
                  <td className="td_date">2022,08,25</td>
                  <td>홍길동103</td>
                  <td className="td_point">보수교육</td>
                  <td>신입 교사 연수 공지입니다. 2022년 교사님…</td>
                  <td>
                    <button className="btn_link point">다운로드</button>
                  </td>
                  <td>김길동103</td>
                  <td>8</td>
                  <td></td>
                  <td>
                    <button className="btn_link blue">보기</button>
                  </td>
                </tr>

                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>17</td>
                      <td className="td_date">2022,08,25</td>
                      <td>홍길동103</td>
                      <td className="td_point">보수교육</td>
                      <td>신입 교사 연수 공지입니다. 2022년 교사님…</td>
                      <td>
                        <button className="btn_link point">다운로드</button>
                      </td>
                      <td>김길동103</td>
                      <td>8</td>
                      <td></td>
                      <td>
                        <button className="btn_link blue">보기</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <div className="com_icon red">공고중</div>
              <p className="name">홍길동103</p>
              <p className="date dot">2025, 05, 20 11 : 30</p>
              <div className="count">
                <button className="btn_edit"></button>
                <button className="btn_delete"></button>
              </div>
            </div>
            <div className="sec_input">
              <input type="text" className="input" placeholder="교사교육 공고명 입력" />
            </div>

            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">교육</span>
                  <span className="cont com_blue_txt">입사자 재교육</span>
                </div>
                <div className="info">
                  <span className="tit">교관</span>
                  <span className="cont bold">김교관103</span>
                </div>
                <div className="info">
                  <span className="tit">회차/시간</span>
                  <span className="cont">2023, 05, 16 ~ 2023, 06, 15</span>
                </div>
                <div className="info">
                  <span className="tit">등록 가능 인원</span>
                  <span className="cont">25명</span>
                </div>
                <div className="info">
                  <span className="tit">요일 시간</span>
                  <span className="cont">매주 월, 화, 금 16:30</span>
                </div>
                <div className="info">
                  <span className="tit">등록 마감일</span>
                  <span className="cont">2023, 05, 16</span>
                </div>
              </div>
            </div>
            <div className="notice_board">
              교사교육 공고 입니다.
              <br />
              홍길동, 김길동, 최길동 3명 필수 참석입니다.
            </div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="cont bold">필수 교육 예정자</span>
                </div>
                <div className="info">
                  <span className="cont ">홍길동103 &nbsp;홍길동103&nbsp;김길동122</span>
                </div>
                <div className="info ">
                  <span className="cont ">최길동978 &nbsp;강길동321&nbsp;김길동654</span>
                </div>
              </div>
            </div>

            <div className="com_input_upload">
              <p className="file">
                <span className="txt">File name.pdf</span>
                <button type="button" className="btn_del_file" onClick={() => {}}></button>
                <button type="button" className="btn_down" onClick={() => {}}></button>
              </p>
              <p className="file">
                <span className="txt">File name.pdf</span>
                <button type="button" className="btn_del_file" onClick={() => {}}></button>
                <button type="button" className="btn_down" onClick={() => {}}></button>
              </p>
            </div>
            <hr className="com_divider" />
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="cont bold">총 참석자 129명</span>
                </div>
                <div className="info">
                  <span className="cont ">홍길동103 &nbsp;홍길동103&nbsp;김길동122</span>
                </div>
                <div className="info ">
                  <span className="cont ">최길동978 &nbsp;강길동321&nbsp;김길동654</span>
                </div>
              </div>
            </div>

            <div className="com_btn_wrap center">
              <button className="com_btn orange s btn_plus">참석자 등록</button>
            </div>
          </section>
        </section>
      </div>
      <PopTrainingNotice open={modalTrainingNotice} close={() => setModalTrainingNotice(false)} />
    </main>
  );
};

export default Notice;
